module.exports = __webpack_public_path__ + "static/media/DirectionIcon.5be94ba5.svg";